import { translation } from "../stores";
import { hangupPeerConnection } from "../stores/peerConnectionStore";
import { roomStateStore } from "../stores/roomStateStore";
import { addToast } from "../stores/toastStore";
import { ROOM_CONNECTION_STATE } from "../types/Room/RoomConnectionState";
import { navigateWithParams } from "./navigation";
export function closeCall(roomId) {
    addToast('error', translation.feedback.text1);
    hangupPeerConnection();
    try {
        navigateWithParams(`/feedback/${roomId}`);
    }
    catch (error) {
        console.warn("[DualVideo][hangup] redirect error", error);
    }
    roomStateStore.set(ROOM_CONNECTION_STATE.IDLE);
}
